var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-frame-genius-my-account grid",
      class: { "grid--gap-4": _vm.isMobile, "grid--gap-5": !_vm.isMobile },
    },
    [
      _c("div", { staticClass: "rb-frame-genius-my-account__title col-12" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.translation("frame_genius.my_account.title")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 grid grid--gap-1" }, [
        _c(
          "div",
          { staticClass: "rb-frame-genius-my-account__icon col-3 col-lg-3" },
          [
            _vm.isFrameGeniusDataPresent
              ? [
                  _c("img", {
                    attrs: { src: _vm.suggestedFeatures.profileImageUrl },
                  }),
                ]
              : [
                  _c(
                    "span",
                    {
                      staticClass:
                        "common__icon common__icon--frame-advisor-black",
                    },
                    [_vm._v("frame genius")]
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "rb-frame-genius-my-account__description col-9 col-lg-5",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.translation("frame_genius.my_account.description")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rb-frame-genius-my-account__button col-12 col-lg-4" },
          [
            _c(
              "button",
              {
                staticClass: "rb-btn rb-btn--black-outline",
                attrs: { type: "button" },
                on: { click: _vm.openFrameGenius },
              },
              [_vm._v("\n        " + _vm._s(_vm.getButtonLabel) + "\n      ")]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }